import {eachDayOfInterval} from 'date-fns';

export const MONTH_NAMES_SHORT = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'Jun',
  'Jul',
  'Aug',
  'Sep',
  'Oct',
  'Nov',
  'Dec',
];

export const MONTH_NAMES_FULL = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];

export const DAY_NAMES_SHORT = [
  'Sun',
  'Mon',
  'Tue',
  'Wed',
  'Thu',
  'Fri',
  'Sat',
];

export const DAY_NAMES_FULL = [
  'Sunday',
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday',
];

// Convert a date string to Eastern Time
export function toEasternTime(dateString) {
  const date = new Date(dateString);
  return new Date(date.toLocaleString('en-US', {timeZone: 'America/New_York'}));
}

// Parse ISO string without converting to local timezone
// Extracts date/time components directly from the string
export function parseISOWithoutConversion(isoString) {
  if (!isoString) return null;
  // Parse: 2025-12-31T20:28:48.510615-08:00
  const match = isoString.match(
    /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2})/,
  );
  if (!match) {
    return null;
  }
  const [, year, month, day, hours, minutes, seconds] = match;
  const yearNum = parseInt(year, 10);
  const monthNum = parseInt(month, 10);
  const dayNum = parseInt(day, 10);
  return {
    year: yearNum,
    month: monthNum,
    day: dayNum,
    hours: parseInt(hours, 10),
    minutes: parseInt(minutes, 10),
    seconds: parseInt(seconds, 10),
    // Calculate day of week from date components (0 = Sunday, 6 = Saturday)
    dayOfWeek: new Date(yearNum, monthNum - 1, dayNum).getDay(),
    // Create a Date object using local timezone interpretation of these components
    toDate: function () {
      return new Date(
        this.year,
        this.month - 1,
        this.day,
        this.hours,
        this.minutes,
        this.seconds,
      );
    },
  };
}

export const getCellStatus = (record) => {
  if (!record || record.valid === false) {
    return 'striped';
  }

  if (record.result === 1) return 'red';

  if (record.result === 0 && record.probability !== null) {
    return record.probability > 0.5 ? 'yellow' : 'green';
  }

  if (record.result === null) return 'grey';

  return 'striped';
};

export const generateDateRange = (startDate, endDate) => {
  return eachDayOfInterval({start: startDate, end: endDate});
};

export const formatDateInput = (date) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};

export const formatDate = (date) => {
  return date.toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  });
};
